import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=2398eccd&scoped=true&"
import script from "./ChannelList.vue?vue&type=script&lang=ts&"
export * from "./ChannelList.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=2398eccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398eccd",
  null
  
)

export default component.exports